module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dash-footer"
    }
  }, [_c('div', {
    staticClass: "font-style font-size-body section-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("© COPYRIGHT 2019 BY VV PHOTOGRAPHER")]), _vm._v(" "), _c('div', {
    staticClass: "section-right"
  }, [_c('div', {
    staticClass: "pull-left nav-footer"
  }, [_c('i', {
    staticClass: "fa fa-facebook-square",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.openNewWindow(_vm.dashFooter.facebook)
      }
    }
  }), _vm._v(" \n        "), _c('span', {
    attrs: {
      "id": "text-footer"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.dashFooter.facebook,
      "target": "_blank"
    }
  }, [_vm._v("Facebook ")])]), _vm._v("| \n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pull-left nav-footer"
  }, [_c('i', {
    staticClass: "fa fa-instagram",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.openNewWindow(_vm.dashFooter.instagram)
      }
    }
  }), _vm._v(" \n        "), _c('span', {
    attrs: {
      "id": "text-footer"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.dashFooter.instagram,
      "target": "_blank"
    }
  }, [_vm._v("Instagram ")])]), _vm._v("| \n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pull-left nav-footer"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.sendEmail(_vm.dashFooter.email)
      }
    }
  }), _vm._v(" \n        "), _c('span', {
    attrs: {
      "id": "text-footer"
    }
  }, [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.dashFooter.email
    }
  }, [_vm._v("Email ")])]), _vm._v(" \n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b06b8af!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dash/components/dashFooter.vue
// module id = 587
// module chunks = 2